import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-yx_icon_left",
  "use": "icon-yx_icon_left-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-yx_icon_left\"><path d=\"M685.226667 256l-256 256 256 256L640 813.226667l-278.613333-278.613334a32 32 0 0 1 0-45.226666L640 210.773333 685.226667 256z\" p-id=\"1386\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgIcons/svg/yx_icon_left.svg
// module id = ID2O
// module chunks = 76